import { useListContext } from "ra-core";
import { BulkExportButton } from "@/components/admin/bulk-export-button";
import { BulkDeleteButton } from "@/components/admin/bulk-delete-button";
import { BulkSMSButton } from "../sms";

/**
 * Custom bulk actions for contacts including SMS sending
 */
export function ContactBulkActions() {
    const { selectedIds } = useListContext();

    return (
        <>
            <BulkSMSButton selectedIds={selectedIds.map(id => Number(id))} />
            <BulkExportButton />
            <BulkDeleteButton />
        </>
    );
}
